<template><div><h1>VUX 2.7.6 发布日志</h1>
<h2><a href="/zh-CN/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[fix] 修复分割线会消失的bug #2322</li>
</ul>
<h2><a href="/zh-CN/components/calendar.html">Calendar</a></h2>
<ul><li>[fix] 修复选中同个日期时无法自动关闭的问题 #2306</li>
</ul>
<h2><a href="/zh-CN/components/load-more.html">LoadMore</a></h2>
<ul><li>[feature] 不再需要设置 `background-color`</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[fix] 修复 在 cancel 或 clear 时没有触发 on-change 和 input 事件</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX 2.7.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// 2.7.6-198.vue?5b0b5a10